import { ensureKeys } from '@/common/react';
import { Button, Flex, Text } from '@mantine/core';
import { IconArrowNarrowLeft } from '@tabler/icons-react';
import { useNavigate } from '@tanstack/react-router';
import { PropsWithChildren } from 'react';
import styles from './header.module.css';

export type HeaderProps = PropsWithChildren<{
	title?: string;
	backTo?: string;
}>;

export const Header = ({ backTo, title, children }: HeaderProps) => {
	const navigate = useNavigate();
	return (
		<Flex
			justify="space-between"
			w="100%"
			align="center"
			h="85px"
			className={styles.container}
			px="xl"
			c="blue.9"
		>
			<Flex align="center">
				{backTo && (
					<Button
						leftSection={<IconArrowNarrowLeft />}
						variant="transparent"
						c="blue.9"
						p="0"
						onClick={() => navigate({ to: backTo })}
					/>
				)}
				{title && <Text className={styles.title}>{title}</Text>}
			</Flex>
			{ensureKeys(children)}
		</Flex>
	);
};
